<template>
    <div class="wrapper presentation-page">
     <div class="page-header header-filter">
                <div class="page-header-image" style="opacity: 0.8; background-image: url('img/project15.jpg')"></div>
                <div class="content-center">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9 ml-auto text-right">
                                <h1 class="title">Make Transaction Easy! </h1>
                                <h4 class="description">In today's world, daily transactions are complicated. We are focusing in connecting different technologies to make daily transactions easier, secure, and faster.</h4>
                                <br/>
                                <div class="buttons">
                                   
                                    <a href="/about" class="btn btn-info btn-lg mr-3">
                                        Learn More
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
  import { Card, InfoSection } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip
    },
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
</style>
